<template>
    <div>
        <main-menu></main-menu>
        <router-view></router-view>
        <main-footer></main-footer>
    </div>
</template>

<script>
    import MainMenu from './MainMenu';
    import MainFooter from './MainFooter';

    export default {
        name: 'app',
        components: {MainMenu, MainFooter},
        data() {
            return {}
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style lang="scss">
</style>
